import * as Svg from './icons';

export const ADJUSTABLE_TEMP_DRAWER = {
  icon: Svg.ConvertibleCompartmentsIcon,
  text: 'Adjustable Temp Drawer',
  alt: 'Convertible Compartments'
};

export const AIR_FILTER = {
  icon: Svg.AirFilterIcon,
  text: 'Air Filter',
  alt: 'Air Filter'
};

export const AUTO_CLOSE_DOORS = {
  icon: Svg.SoftCloseMechanismIcon,
  text: 'Auto-Close Doors',
  alt: 'Soft-Close Mechanism'
};

export const AUTO_FILL_DISPENSER = {
  icon: Svg.WaterDispenserIcon,
  text: 'Auto-Fill Dispenser',
  alt: 'Water Dispenser'
};

export const AUTO_FILL_PITCHER = {
  icon: Svg.WaterPitcherIcon,
  text: 'AutoFill Pitcher',
  alt: 'Water Pitcher'
};

export const AUTO_OPEN_DOOR = {
  icon: Svg.SoftCloseMechanismIcon,
  text: 'Auto Open Door',
  alt: 'Soft-Close Mechanism'
};

export const CONVERTIBLE_COMPARTMENT = {
  icon: Svg.ConvertibleCompartmentsIcon,
  text: 'Convertible Compartment',
  alt: 'Convertible Compartments'
};

export const CONVERTIBLE_DRAWER = {
  icon: Svg.ConvertibleCompartmentsIcon,
  text: 'Convertible Drawer',
  alt: 'Convertible Compartments'
};

export const CONVERTIBLE_ZONE = {
  icon: Svg.ConvertibleCompartmentsIcon,
  text: 'Convertible Zone',
  alt: 'Convertible Compartments'
};

export const COUNTER_DEPTH = {
  icon: Svg.CounterDepthIcon,
  text: 'Counter Depth',
  alt: 'Counter Depth'
};

export const CUSTOMIZABLE_HARDWARE = {
  icon: Svg.CustomizablePanelsIcon,
  text: 'Customizable Hardware',
  alt: 'Customizable Panels'
};

export const CUSTOMIZABLE_PANELS = {
  icon: Svg.CustomizablePanelsIcon,
  text: 'Customizable Panels',
  alt: 'Customizable Panels'
};

export const DELI_DRAWER = {
  icon: Svg.PantryDrawerIcon,
  text: 'Deli Drawer',
  alt: 'Pantry Drawer'
};

export const DIGITAL_TEMP_CONTROL = {
  icon: Svg.DigitalTempControlIcon,
  text: 'Digital Temp Control',
  alt: 'Digital Temp Control'
};

export const DUAL_CRISPERS = {
  icon: Svg.CrisperDrawersIcon,
  text: 'Dual Crispers',
  alt: 'Crisper Drawers'
};

export const DUAL_COMPRESSORS_COOLING_SYSTEM = {
  icon: Svg.CoolingSystemIcon,
  text: 'Dual Compressors',
  alt: 'Cooling System'
};

export const DUAL_COMPRESSORS_TEMPERATURE_CONTROL = {
  icon: Svg.TemperatureControlIcon,
  text: 'Dual Compressors',
  alt: 'Temperature Control'
};

export const DUAL_COOLING_COOLING_SYSTEM = {
  icon: Svg.CoolingSystemIcon,
  text: 'Dual Cooling',
  alt: 'Cooling System'
};

export const DUAL_COOLING_TEMPERATURE_CONTROL = {
  icon: Svg.TemperatureControlIcon,
  text: 'Dual Cooling',
  alt: 'Temperature Control'
};

export const DUAL_EVAPORATORS = {
  icon: Svg.CoolingSystemIcon,
  text: 'Dual Evaporators',
  alt: 'Cooling System'
};

export const DUAL_ICE_MAKER_ICE_MAKER = {
  icon: Svg.IceMakerIcon,
  text: 'Dual Ice Maker',
  alt: 'Ice Maker'
};

export const DUAL_ICE_MAKER_MULTIPLE_ICE_MAKERS = {
  icon: Svg.MultipleIceMakersIcon,
  text: 'Dual Ice Maker',
  alt: 'Multiple Ice Makers'
};

export const ENERGY_MONITORING = {
  icon: Svg.EnergyMonitoringIcon,
  text: 'Energy Monitoring',
  alt: 'Energy Monitoring'
};

export const ENERGY_SAVING_MODE = {
  icon: Svg.EnergyMonitoringIcon,
  text: 'Energy Saving Mode',
  alt: 'Energy Monitoring'
};

export const ETHYLENE_FILTER = {
  icon: Svg.AirFilterIcon,
  text: 'Ethylene Filter',
  alt: 'Air Filter'
};

export const EVEN_COOLING = {
  icon: Svg.CoolingSystemIcon,
  text: 'Even Cooling',
  alt: 'Cooling System'
};

export const EXTERNAL_WATER_DISPENSER = {
  icon: Svg.WaterDispenserIcon,
  text: 'External Water Dispenser',
  alt: 'Water Dispenser'
};

export const FAST_CHILL = {
  icon: Svg.FastCoolingIcon,
  text: 'Fast Chill',
  alt: 'Fast Cooling'
};

export const FAST_CHILL_AND_FREEZE = {
  icon: Svg.FastCoolingIcon,
  text: 'Fast Chill & Freeze',
  alt: 'Fast Cooling'
};

export const FAST_COOLING = {
  icon: Svg.FastCoolingIcon,
  text: 'Fast Cooling',
  alt: 'Fast Cooling'
};

export const FAST_COOL_AND_FREEZE = {
  icon: Svg.TemperatureControlIcon,
  text: 'Fast Cool & Freeze',
  alt: 'Temperature Control'
};

export const FAST_ICE_FAST_ICE_PRODUCTION = {
  icon: Svg.FastIceProductionIcon,
  text: 'Fast Ice',
  alt: 'Fast Ice Production'
};

export const FAST_ICE_ICE_MAKER = {
  icon: Svg.IceMakerIcon,
  text: 'Fast Ice',
  alt: 'Ice Maker'
};

export const FAST_ICE_PRODUCTION = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: 'Fast Ice Production',
  alt: 'Ice Capacity & Storage'
};

export const FINGERPRINT_RESISTANT = {
  icon: Svg.FingerprintResistantIcon,
  text: 'Fingerprint Resistant',
  alt: 'Fingerprint Resistant'
};

export const FIVE_FIVE_LBS_ICE_CAPACITY = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: '5.5 lbs Ice Capacity',
  alt: 'Ice Capacity & Storage'
};

export const FIVE_STORAGE_ZONES = {
  icon: Svg.StorageZonesIcon,
  text: '5 Storage Zones',
  alt: 'Storage Zones'
};

export const FIVE_TEMP_DRAWER = {
  icon: Svg.ConvertibleCompartmentsIcon,
  text: '5-Temp Drawer',
  alt: 'Convertible Compartments'
};

export const FOOD_RECOGNITION_CAMERA = {
  icon: Svg.InternalCameraIcon,
  text: 'Food Recognition Camera',
  alt: 'Internal Camera'
};

export const FOUR_ICE_TYPES = {
  icon: Svg.SpecialtyIceIcon,
  text: '4 Ice Types',
  alt: 'Specialty Ice'
};

export const FRAMELESS_SHELVES = {
  icon: Svg.SpillProofShelvesIcon,
  text: 'Frameless Shelves',
  alt: 'Spill-Proof Shelves'
};

export const FRESHNESS_SYSTEM = {
  icon: Svg.HumidityControlIcon,
  text: 'Freshness System',
  alt: 'Humidity Control'
};

export const FULL_WIDTH_DRAWER = {
  icon: Svg.PantryDrawerIcon,
  text: 'Full-Width Drawer',
  alt: 'Pantry Drawer'
};

export const GALLON_DOOR_BINS = {
  icon: Svg.DoorStorageIcon,
  text: 'Gallon Door Bins',
  alt: 'Door Storage'
};

export const GARAGE_READY = {
  icon: Svg.GarageReadyIcon,
  text: 'Garage Ready',
  alt: 'Garage Ready'
};

export const HIDDEN_WATER_DISPENSER = {
  icon: Svg.WaterDispenserIcon,
  text: 'Hidden Water Dispenser',
  alt: 'Water Dispenser'
};

export const HIGH_CAPACITY_ICE = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: 'High-Capacity Ice',
  alt: 'Ice Capacity & Storage'
};

export const HUMIDITY_CONTROL = {
  icon: Svg.HumidityControlIcon,
  text: 'Humidity Control',
  alt: 'Humidity Control'
};

export const ICE_DISPENSER = {
  icon: Svg.IceDispenserIcon,
  text: 'Ice Dispenser',
  alt: 'Ice Dispenser'
};

export const ICE_MAKER = {
  icon: Svg.IceMakerIcon,
  text: 'Ice Maker',
  alt: 'Ice Maker'
};

export const INDEPENDENT_TEMP_CONTROLS = {
  icon: Svg.TemperatureControlIcon,
  text: 'Independent Temp Controls',
  alt: 'Temperature Control'
};

export const INTERNAL_CAMERA = {
  icon: Svg.InternalCameraIcon,
  text: 'Internal Camera',
  alt: 'Internal Camera'
};

export const INTERNAL_ICE_DISPENSER = {
  icon: Svg.IceDispenserIcon,
  text: 'Internal Ice Dispenser',
  alt: 'Ice Dispenser'
};

export const INTERNAL_WATER_DISPENSER = {
  icon: Svg.WaterDispenserIcon,
  text: 'Internal Water Dispenser',
  alt: 'Water Dispenser'
};

export const IN_DOOR_ICE_MAKER = {
  icon: Svg.IceMakerIcon,
  text: 'In-Door Ice Maker',
  alt: 'Ice Maker'
};

export const LARGE_CAPACITY_ICE_MAKER = {
  icon: Svg.IceMakerIcon,
  text: 'Large Capacity Ice Maker',
  alt: 'Ice Maker'
};

export const MEASURED_WATER_FILL = {
  icon: Svg.WaterDispenserIcon,
  text: 'Measured Water Fill',
  alt: 'Water Dispenser'
};

export const NESTING_SHELF = {
  icon: Svg.RetractableShelvesIcon,
  text: 'Nesting Shelf',
  alt: 'Retractable Shelves'
};

export const ODOR_FILTER = {
  icon: Svg.AirFilterIcon,
  text: 'Odor Filter',
  alt: 'Air Filter'
};

export const ONE_ONE_LBS_ICE_CAPACITY = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: '11 lbs Ice Capacity',
  alt: 'Ice Capacity & Storage'
};

export const ONE_TOUCH_BOTTLE_FILL = {
  icon: Svg.WaterDispenserIcon,
  text: 'One-Touch Bottle Fill',
  alt: 'Water Dispenser'
};

export const ONE_TWO_FIVE_LBS_ICE_CAPACITY = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: '12.5 lbs Ice Capacity',
  alt: 'Ice Capacity & Storage'
};

export const PANTRY_DRAWER = {
  icon: Svg.PantryDrawerIcon,
  text: 'Pantry Drawer',
  alt: 'Pantry Drawer'
};

export const PINT_STORAGE = {
  icon: Svg.PintStorageIcon,
  text: 'Pint Storage',
  alt: 'Pint Storage'
};

export const PIZZA_STORAGE = {
  icon: Svg.SpecialtyStorageIcon,
  text: 'Pizza Storage',
  alt: 'Specialty Storage'
};

export const PORTABLE_DOOR_BIN = {
  icon: Svg.DoorStorageIcon,
  text: 'Portable Door Bin',
  alt: 'Door Storage'
};

export const PRECISE_TEMP_CONTROL = {
  icon: Svg.TemperatureControlIcon,
  text: 'Precise Temp Control',
  alt: 'Temperature Control'
};

export const PRECISION_COOLING = {
  icon: Svg.CoolingSystemIcon,
  text: 'Precision Cooling',
  alt: 'Cooling System'
};

export const PREP_STORAGE_BINS = {
  icon: Svg.PrepStorageBinsIcon,
  text: 'Prep Storage Bins',
  alt: 'Prep Storage Bins'
};

export const PROACTIVE_ALERTS = {
  icon: Svg.AlertsIcon,
  text: 'Proactive Alerts',
  alt: 'Alerts'
};

export const PRODUCE_PRESERVER = {
  icon: Svg.HumidityControlIcon,
  text: 'Produce Preserver',
  alt: 'Humidity Control'
};

export const PYRAMID_ICE = {
  icon: Svg.SpecialtyIceIcon,
  text: 'Pyramid Ice',
  alt: 'Specialty Ice'
};

export const PYRAMID_ICE_MAKER = {
  icon: Svg.IceMakerIcon,
  text: 'Pyramid Ice Maker',
  alt: 'Ice Maker'
};

export const RETRACTABLE_SHELF = {
  icon: Svg.RetractableShelvesIcon,
  text: 'Retractable Shelf',
  alt: 'Retractable Shelves'
};

export const REVERSIBLE_CRISPER = {
  icon: Svg.CrisperDrawersIcon,
  text: 'Reversible Crisper',
  alt: 'Crisper Drawers'
};

export const SABBATH_MODE = {
  icon: Svg.SpecialModesIcon,
  text: 'Sabbath Mode',
  alt: 'Special Modes'
};

export const SEALED_CRISPERS = {
  icon: Svg.CrisperDrawersIcon,
  text: 'Sealed Crispers',
  alt: 'Crisper Drawers'
};

export const SEVEN_LBS_ICE_CAPACITY = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: '7 lbs Ice Capacity',
  alt: 'Ice Capacity & Storage'
};

export const SIX_ZERO_FOUR_ZERO_PRODUCE_DRAWERS = {
  icon: Svg.ProduceDrawersIcon,
  text: '60/40 Produce Drawers',
  alt: '60/40 Produce Drawers'
};

export const SLIDE_IN_SHELF = {
  icon: Svg.RetractableShelvesIcon,
  text: 'Slide-in Shelf',
  alt: 'Retractable Shelves'
};

export const SLIDE_OUT_SHELF = {
  icon: Svg.RetractableShelvesIcon,
  text: 'Slide-Out Shelf',
  alt: 'Retractable Shelves'
};

export const SLIDING_STORAGE_TRAY = {
  icon: Svg.RetractableShelvesIcon,
  text: 'Sliding Storage Tray',
  alt: 'Retractable Shelves'
};

export const SLIM_IN_DOOR_ICE_MAKER = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: 'Slim In-Door Ice Maker',
  alt: 'Ice Capacity & Storage'
};

export const SMART_COOLING = {
  icon: Svg.CoolingSystemIcon,
  text: 'Smart Cooling',
  alt: 'Cooling System'
};

export const SMART_FEATURES = {
  icon: Svg.SmartFeaturesIcon,
  text: 'Smart Features',
  alt: 'Smart Features'
};

export const SOFT_CLOSE_DOORS = {
  icon: Svg.SoftCloseMechanismIcon,
  text: 'Soft-Close Doors',
  alt: 'Soft-Close Mechanism'
};

export const SOFT_CLOSE_DRAWERS = {
  icon: Svg.SoftCloseMechanismIcon,
  text: 'Soft-Close Drawers',
  alt: 'Soft-Close Mechanism'
};

export const SPACE_SAVING_ICE = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: 'Space-Saving Ice',
  alt: 'Ice Capacity & Storage'
};

export const TALL_DISPENSER = {
  icon: Svg.WaterDispenserIcon,
  text: 'Tall Dispenser',
  alt: 'Water Dispenser'
};

export const TEMPERATURE_CONTROL = {
  icon: Svg.TemperatureControlIcon,
  text: 'Temperature Control',
  alt: 'Temperature Control'
};

export const TEMP_CONTROL = {
  icon: Svg.TemperatureControlIcon,
  text: 'Temp Control',
  alt: 'Temperature Control'
};

export const THREE_SEVEN_LBS_ICE_CAPACITY = {
  icon: Svg.IceCapacityAndStorageIcon,
  text: '3.7 lbs Ice Capacity',
  alt: 'Ice Capacity & Storage'
};

export const THREE_TEMP_DRAWER = {
  icon: Svg.ConvertibleCompartmentsIcon,
  text: '3-Temp Drawer',
  alt: 'Convertible Compartments'
};

export const THREE_TIER_FREEZER = {
  icon: Svg.FreezerOrganizationIcon,
  text: '3-Tier Freezer',
  alt: 'Freezer Organization'
};

export const THREE_TWO_IN_TOUCHSCREEN = {
  icon: Svg.TouchControlsIcon,
  text: '32-in Touchscreen',
  alt: 'Touch Controls'
};

export const TRIPLE_EVAPORATORS = {
  icon: Svg.CoolingSystemIcon,
  text: 'Triple Evaporators',
  alt: 'Cooling System'
};

export const TRIPLE_ICE_MAKER = {
  icon: Svg.MultipleIceMakersIcon,
  text: 'Triple Ice Maker',
  alt: 'Multiple Ice Makers'
};

export const TWO_FREEZER_DRAWERS = {
  icon: Svg.TwoFreezerDrawersIcon,
  text: '2 Freezer Drawers',
  alt: '2 Freezer Drawers'
};

export const TWO_ICE_TYPES = {
  icon: Svg.SpecialtyIceIcon,
  text: '2 Ice Types',
  alt: 'Specialty Ice'
};

export const TWO_SIX_CU_FT = {
  icon: Svg.CapacityIcon,
  text: '26 cu. ft.',
  alt: 'Capacity'
};

export const TWO_TIER_FREEZER = {
  icon: Svg.FreezerOrganizationIcon,
  text: '2-Tier Freezer',
  alt: 'Freezer Organization'
};

export const UPRIGHT_PIZZA_STORAGE = {
  icon: Svg.SpecialtyStorageIcon,
  text: 'Upright Pizza Storage',
  alt: 'Specialty Storage'
};

export const VACATION_MODE = {
  icon: Svg.SpecialModesIcon,
  text: 'Vacation Mode',
  alt: 'Special Modes'
};

export const WATER_AND_ICE_DISPENSER = {
  icon: Svg.WaterAndIceDispenserIcon,
  text: 'Water & Ice Dispenser',
  alt: 'Water & Ice Dispenser'
};

export const WATER_DISPENSER = {
  icon: Svg.WaterDispenserIcon,
  text: 'Water Dispenser',
  alt: 'Water Dispenser'
};

export const WI_FI_ENABLED = {
  icon: Svg.SmartFeaturesIcon,
  text: 'Wi-Fi Enabled',
  alt: 'Smart Features'
};

